export enum TrackingEventEnum {
  // App lifecycle events
  FIRST_APP_OPEN = 'firstAppOpen',
  APP_WILL_TERMINATE = 'appWillTerminate',

  // Permission-related events
  MICROPHONE_PERMISSION_REQUESTED = 'microphonePermissionRequested',
  MICROPHONE_PERMISSION_GRANTED = 'microphonePermissionGranted',
  MICROPHONE_PERMISSION_DENIED = 'microphonePermissionDenied',
  MICROPHONE_PERMISSION_PROMPTED = 'microphonePermissionPrompted',
  SPEECH_RECOGNITION_PERMISSION_REQUESTED = 'speechRecognitionPermissionRequested',
  SPEECH_RECOGNITION_PERMISSION_GRANTED = 'speechRecognitionPermissionGranted',
  SPEECH_RECOGNITION_PERMISSION_DENIED = 'speechRecognitionPermissionDenied',
  SPEECH_RECOGNITION_PERMISSION_PROMPTED = 'speechRecognitionPermissionPrompted',
  ATT_PERMISSION_REQUESTED = 'ATTPermissionRequested',
  ATT_PERMISSION_GRANTED = 'ATTPermissionGranted',
  ATT_PERMISSION_DENIED = 'ATTPermissionDenied',
  ATT_PERMISSION_PROMPTED = 'ATTPermissionPrompted',
  APP_CLOSED_DUE_TO_SETTING_PERMISSION = 'appClosedDueToSettingPermission',
  APP_CLOSED_DUE_TO_PERMISSION_DENIED = 'appClosedDueToPermissionDenied',

  // Feedback-related events
  FEEDBACK_CANCEL_TAPPED = 'feedbackCancelTapped',
  FEEDBACK_TOP_BUTTON_TAPPED = 'feedbackTopButtonTapped',
  FEEDBACK_BOTTOM_BUTTON_TAPPED = 'feedbackBottomButtonTapped',
  FEEDBACK_PROVIDED_LESSON_END = 'feedbackProvidedLessonEnd',
  FEEDBACK_PROVIDED_GENERAL = 'feedbackProvidedGeneral',

  // Account-related events
  ACCOUNT_BUTTON_TAPPED = 'accountButtonTapped',
  PARENT_SIGN_UP = 'parentSignUp',
  PARENT_SIGN_UP_FAILED = 'parentSignUpFailed',
  PARENT_SIGN_IN = 'parentSignIn',
  PARENT_SIGN_OUT = 'parentSignOut',
  PARENT_DELETE_ACCOUNT = 'parentDeleteAccount',
  AUTH_ERROR = 'authError',
  USER_FORGOT_PASSWORD_INITIATED = 'userForgotPasswordInitiated',
  USER_FORGOT_PASSWORD_CODE_ENTERED = 'userForgotPasswordCodeEntered',
  USER_FORGOT_PASSWORD_FAILED = 'userForgotPasswordFailed',
  USER_FORGOT_PASSWORD_EMAIL_SENT = 'userForgotPasswordEmailSent',
  USER_FORGOT_PASSWORD_COMPLETED = 'userForgotPasswordCompleted',
  USER_ACCOUNT_INFO_CHANGED = 'userAccountInfoChanged',
  USER_DETAILS_UPDATE_FAILED = 'userDetailsUpdateFailed',
  PASSWORD_UPDATE_FAILED = 'passwordUpdateFailed',
  CHILD_DETAILS_UPDATE_FAILED = 'childDetailsUpdateFailed',
  CHILD_PROFILE_CREATED = 'childProfileCreated',
  CHILD_PROFILE_CREATION_FAILED = 'childProfileCreationFailed',
  PARENT_ACCOUNT_UPDATED = 'parentAccountUpdated',
  PARENT_ACCOUNT_UPDATE_FAILED = 'parentAccountUpdateFailed',
  PASSWORD_CHANGED = 'passwordChanged',
  PASSWORD_CHANGE_FAILED = 'passwordChangeFailed',
  CHILD_PROFILE_UPDATED = 'childProfileUpdated',
  CHILD_PROFILE_UPDATE_FAILED = 'childProfileUpdateFailed',
  APP_SETTINGS_UPDATED = 'appSettingsUpdated',
  APP_SETTINGS_UPDATE_FAILED = 'appSettingsUpdateFailed',
  PARENT_ACCOUNT_DELETION_FAILED = 'parentAccountDeletionFailed',
  PARENT_ACCOUNT_DELETED = 'parentAccountDeleted',

  // Home view events
  GOD_MODE_TOGGLED = 'godModeToggled',

  // Parent info form events
  PARENT_INFO_FORM_OPENED = 'parentInfoFormOpened',
  PARENT_INFO_SUBMITTED = 'parentInfoSubmitted',
  PRIVACY_POLICY_OPENED = 'privacyPolicyOpened',
  BEGIN_READING_JOURNEY_TAPPED = 'beginReadingJourneyTapped',

  // Lesson events
  INITIAL_STEP_LOADED = 'initialStepLoaded',
  STEP_COMPLETED = 'stepCompleted',
  STEP_ANSWERED = 'stepAnswered',
  STEP_FEEDBACK_GIVEN = 'stepFeedbackGiven',
  STEP_UNCOMPLETED = 'stepUncompleted',
  TASK_COMPLETED_REVIEW = 'taskCompletedReview',
  TASK_COMPLETED = 'taskCompleted',
  TASK_UNCOMPLETED_REVIEW = 'taskUncompletedReview',
  TASK_UNCOMPLETED = 'taskUncompleted',
  STEP_ABORTED = 'stepAborted',
  STEP_NAVIGATED = 'stepNavigated',
  STEP_COMPLETED_REVIEW = 'stepCompletedReview',
  STEP_UNCOMPLETED_REVIEW = 'stepUncompletedReview',
  LESSON_NAVIGATED = 'lessonNavigated',
  TASK_NAVIGATED = 'taskNavigated',
  STEP_COMPLETED_CORRECTLY = 'stepCompletedCorrectly',
  STEP_ASSUMED_CORRECT = 'stepAssumedCorrect',
  STEP_COMPLETED_INCORRECTLY = 'stepCompletedIncorrectly',
  FIRST_LESSON_COMPLETED = 'firstLessonCompleted',
  LESSON_COMPLETED = 'lessonCompleted',

  // Help Manager events
  STEP_CHOSE_TO_SKIP = 'stepChoseToSkip',
  STEP_CHOSE_TO_RETRY = 'stepChoseToRetry',

  // App Lifecycle events
  APP_BECAME_ACTIVE = 'appBecameActive',
  APP_WILL_RESIGN_ACTIVE = 'appWillResignActive',
  APP_ENTERED_BACKGROUND = 'appEnteredBackground',
  UNKNOWN_SCENE_PHASE = 'unknownScenePhase',

  // Graders
  CHECK_ANSWER_FAILED = 'checkAnswerFailed',

  // Magic Link
  MAGIC_LINK_AUTHENTICATION_COMPLETE = 'magicLinkAuthenticationComplete',
}
